import React, { FC } from "react";
import { LinkButton } from "@app/components/common/link-button/LinkButton";
import { Button } from "../../models";

type Props = {
  data: Button;
};

export const LinkButtonAdapter: FC<Props> = ({ data }) => (
  <LinkButton
    to={data.to.url || data.to.id}
    label={data.title}
    variant={data.variant}
    type={data.type}
    storyblokType={data.to.linktype}
    fileRef={data.file?.filename}
    fileName={data.file?.filename?.split("/").pop()}
    isShowOnMobileApp={data.isShowOnMobileApp}
    isOpenInNewTab={data.to.target === "_blank"}
  />
);
